














































// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator';
import {AloSection} from '@/models/alo/AloSection'
import { AloSejour } from '@/models/alo/AloSejour';

@Component({
  name: 'Home',  
})
export default class Home extends Vue {

  get userName(){
    return this.$store.myGetters.user.usrPrenom + " " + this.$store.myGetters.user.usrNom
  }

  get canOrder() {
    return this.$store.myGetters.canOrder
  }

  get isVisiteur() {
    return this.$store.myGetters.isVisiteur
  }  


  get sectionsList():Array<AloSection>{
    return this.$store.myGetters.sectionsList
  }
}
